import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import Icon from '@veeva/corgix/icon';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import useMessageService from '../../services/i18n/useMessageService';
import Button from '../../components/Button';
import buildAndSubmitForm from '../../services/buildAndSubmitForm';
import getTargetAttribute from '../../services/getTargetAttribute';

const PasswordSavedConfirmation = ({ targetUrl, requestState }) => {
    const [[buttonLabel = 'Continue']] = useMessageService(['general.continue']);

    const handleClickContinueButton = () => {
        buildAndSubmitForm(targetUrl, requestState);
    };

    return (
        <div
            css={({ green }) => {
                return css`
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 3.33rem;

                    svg[data-icon='check-circle'] {
                        width: 8.333rem;
                        height: 8.333rem;
                        color: ${green};
                    }
                `;
            }}
        >
            <Icon type={faCheckCircle} />
            <Button
                onClick={handleClickContinueButton}
                data-target={getTargetAttribute('login-page-button')}
            >
                {buttonLabel}
            </Button>
        </div>
    );
};

PasswordSavedConfirmation.propTypes = {
    requestState: PropTypes.shape({
        notificationToken: PropTypes.string,
        requestId: PropTypes.string,
    }),
    targetUrl: PropTypes.string,
};

export default PasswordSavedConfirmation;
